// utils/modules/utf8-codes/numberMapping.ts
const numbersMapping: Record<number, string> = {
  48: "0",
  1776: "0",
  1632: "0",
  49: "1",
  1777: "1",
  1633: "1",
  50: "2",
  1778: "2",
  1634: "2",
  51: "3",
  1779: "3",
  1635: "3",
  52: "4",
  1780: "4",
  1636: "4",
  53: "5",
  1781: "5",
  1637: "5",
  54: "6",
  1782: "6",
  1638: "6",
  55: "7",
  1783: "7",
  1639: "7",
  56: "8",
  1784: "8",
  1640: "8",
  57: "9",
  1785: "9",
  1641: "9",
};

export default numbersMapping;
